import React from 'react';

export const InterfaceWrapper = ({ Step, Interface }) => ({ presentation, ...props }) => {
  return presentation ? <Step {...props} /> : <Interface {...props} />;
};
